import { useMutation } from "@tanstack/react-query";

import {

    verifyAuthorizationTransaction,

} from "../services/payments";

export function useVerifyAuthorizationTransaction() {

    return useMutation({

        mutationFn:

            verifyAuthorizationTransaction,

    });

}